import { context, utils } from '@ad-engine/core';
import { PrebidAdapter } from '../prebid-adapter';
import {
	PrebidAdSlotConfig,
	PrebidPlcmtVideoSubtypes,
	PrebidVideoPlacements,
} from '../prebid-models';

export class AppnexusAst extends PrebidAdapter {
	static bidderName = 'appnexusAst';
	aliases = {
		appnexus: [AppnexusAst.bidderName],
	};
	bidderSettings = {
		storageAllowed: true,
	};

	debugPlacementId: string;
	isDebugMode: boolean;

	constructor(options) {
		super(options);

		/* Added in to prevent the default -1 value from being assigned. This should come from Audigent,
		but the data loads in too late. We need this value to be default for a specific Microsoft campaign, until
		we can figure out how to get the Audigent data before the first bid call occurs. */
		const appNexusDefaultAuSeg = context.get('options.forceDefaultAuSegOnAppNexus');
		if (appNexusDefaultAuSeg) {
			this.pageTargeting['AU_SEG'] = [appNexusDefaultAuSeg];
		}

		this.debugPlacementId = options.debugPlacementId;
		this.isDebugMode = utils.queryString.get('appnexusast_debug_mode') === '1';
	}

	get bidderName(): string {
		return AppnexusAst.bidderName;
	}

	prepareConfigForAdUnit(code, { placementId }: PrebidAdSlotConfig): PrebidAdUnit {
		return {
			code,
			mediaTypes: {
				video: {
					context: 'instream',
					playerSize: [640, 480],
				},
			},
			ortb2Imp: this.getOrtb2Imp(code),
			bids: [
				{
					bidder: this.bidderName,
					params: {
						placementId: this.isDebugMode ? this.debugPlacementId : placementId,
						keywords: {
							...this.getTargeting(code),
						},
						video: {
							skippable: false,
							playback_method: ['auto_play_sound_off'],
							placement: PrebidVideoPlacements.IN_ARTICLE,
							plcmt: PrebidPlcmtVideoSubtypes.ACCOMPANYING_CONTENT,
						},
					},
				},
			],
		};
	}
}
